<ix-layout-grid columns="12">
  <ix-row>
    <ix-col>
      <ix-content-header
        (backButtonClick)="onBackButtonClick()"
        [hasBackButton]="true"
        headerTitle="{{ 'um.add_user' | translate }}"
        id="inviteUserHeader"
      ></ix-content-header>
    </ix-col>
  </ix-row>
  <ix-row>
    <ix-col>
      <app-user-form
        (userDataChange)="inviteUser($event)"
        [cancelEvent]="cancelEvent"
        [cancelRoute]="targetRoute"
        [loading]="loading"
      ></app-user-form>
    </ix-col>
  </ix-row>
</ix-layout-grid>
